import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Activity } from './activity.interface';
import { ActivityService } from './activity.service';
const service = new ActivityService();

export interface ActivityState {}

const ActivityStore: Module<ActivityState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getFilteredActivities(context, payload: { syncId: string; type: 'candidate' | 'customer'; query: LocationQuery }) {
         if (payload.type === 'candidate') {
            return await service.getFilteredCandidateActivities(payload.syncId, payload.query);
         }
         return await service.getFilteredCustomerActivities(payload.syncId, payload.query);
      },
      async getActivities() {
         return await service.getActivities();
      },
      async getActivity() {
         return await service.getActivity();
      },
      async postActivity() {
         return await service.postActivity();
      },
      async putActivity(context, payload: { id: number; is_pinned: Activity['is_pinned'] }) {
         return await service.putActivity(payload.id, payload.is_pinned);
      },
      async deleteActivity() {
         return await service.deleteActivity();
      },
   },
};

export default ActivityStore;
